import React from 'react';
import PropTypes from 'prop-types';

class MissionCard extends React.Component {
  render() {
    const { name, year, country, destination } = this.props;
    return (
      <div data-testid="mission-card">
        <div className="planetscontainer">
          <section className="principal">
            <div className="missoes">
              <p data-testid="mission-name">{name}</p>
              <hr className="hr" />
              <p data-testid="mission-year">{year}</p>

              <p data-testid="mission-country">{country}</p>

              <p data-testid="mission-destination">{destination}</p>
            </div>
          </section>
        </div>
      </div>
    );
  }
}

MissionCard.propTypes = {
  name: PropTypes.string,
  year: PropTypes.string,
  country: PropTypes.string,
  destination: PropTypes.string,
}.isRequired;

export default MissionCard;
